export const BRUINS09_LEAGUE_SETTINGS = {
  leagueId: '19953',
  name: "Brentwood Bruins '09",
  platform: 'Yahoo Fantasy Football',
  teams: 10,
  scoringType: 'Head-to-Head',
  draftType: 'Live Standard Draft',
  draftRounds: 17,
  secondsPerPick: 120,
  keeperToolsEnabled: true,
  keeperDeadlineLabel: 'Wed Aug 26 12:00am PDT',
  draftLabel: 'Sat Aug 29 2:00pm PDT',
  draftPickTradesEnabled: true,
  tradedPicksImported: true,
  tradeDeadlineLabel: 'Nov 28, 2026',
  waivers: {
    type: 'FAB with reverse standings tiebreak',
    processing: 'Game Time - Tuesday',
    waiverTimeDays: 1,
    startingBudget: 100,
  },
  playoffs: {
    teams: 6,
    startWeek: 15,
    endWeek: 17,
    reseeding: false,
    tiebreaker: 'Best regular-season head-to-head record',
  },
  roster: {
    starters: {
      QB: 2,
      WR: 3,
      RB: 2,
      TE: 1,
      FLEX: 1,
      K: 1,
      DEF: 1,
    },
    flexPositions: ['WR', 'RB', 'TE'],
    bench: 6,
    ir: 1,
  },
  scoring: {
    fractionalPoints: true,
    negativePoints: true,
    passingTouchdown: 6,
    passingYardsPerPoint: 25,
    passingBonuses: [
      { yards: 350, points: 5 },
      { yards: 450, points: 5 },
      { yards: 550, points: 5 },
    ],
    interception: -2,
    rushingAttempt: 0.33,
    rushingYardsPerPoint: 10,
    rushingBonuses: [
      { yards: 100, points: 5 },
      { yards: 200, points: 5 },
      { yards: 300, points: 5 },
    ],
    reception: 1,
    receivingYardsPerPoint: 10,
    receivingBonuses: [
      { yards: 100, points: 5 },
      { yards: 200, points: 5 },
      { yards: 300, points: 5 },
    ],
    returnYardsPerPoint: 20,
  },
  keeperResearch: {
    eligibility: 'all_roster_positions',
    defaultPositions: ['QB', 'RB', 'WR', 'TE', 'K', 'DEF'],
    specialTeamsPositions: ['K', 'DEF'],
    specialTeamsEligibility: 'eligible_low_priority',
    tradedPlayerCost: 'original_2025_draft_round',
    waiverPickupsEligible: true,
    waiverPickupCost: 'no_pick_forfeited',
  },
};
